import { Switch, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const [checked, setChecked] = useState(false);

	const onChange = (event: object, value: boolean) => {
		setChecked(value);
	};

	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="enabled" />
			<Text semiBold text="disabled" />
			<Text semiBold text="disabled + checked" />
			<Switch checked={checked} onChange={onChange} />
			<Switch checked={false} disabled />
			<Switch checked disabled />
		</CssColumnGrid>
	);
};